import React, { useState, useEffect } from "react";
import List from "../../styledComponents/Table/List";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import SearchIcon from "../../../assets/images/DeathModuleNew/Search.png";
import DEATH_API from "../../../apis/death.api";
import { Modal, Select } from "antd";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import "./permission.css";
import swal from "sweetalert";
const { Option } = Select;

export const PermissionMain = () => {
  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [updatedObject, setUpdateObject] = useState(null);
  const [roleModal, setRoleModal] = useState(false);
  const [permissionList, setPermissionList] = useState([]);
  const [formData, setFormData] = useState(null);

  const cols = [
    {
      title: "ID",
      dataIndex: "id",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Permission",
      dataIndex: "name",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "End Point",
      dataIndex: "api",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Action",
      render: (record, index) => {
        return (
          <div key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}>
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        deleteSelectedRow(record.id);
                        setDropdown(false);
                      }}>
                      Delete
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        setRoleModal(true);
                        setDropdown(false);
                      }}>
                      Update
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}{" "}
          </div>
        );
      },
    },
  ];

  const getPermissionList = async () => {
    try {
      (async () => {
        setLoading(true);
        let data = await DEATH_API.getPermissions();
        if (data && data.data) {
          setPermissionList(data.data);
        }
        setLoading(false);
      })();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    console.log("calling api");
    getPermissionList();
  }, []);
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
    let selectedRow = permissionList.filter((row, index) => {
      return row.id == id;
    });

    console.log("selectedRow", selectedRow[0]);
    setFormData(selectedRow[0]);
    setUpdateObject(selectedRow[0]);
  };
  const handleOk = () => {
    setRoleModal(false);
    setFormData(null);
    setUpdateObject(null);
  };
  const handleCancel = () => {
    setRoleModal(false);
    setFormData(null);
    setUpdateObject(null);
  };
  const handleInputChnage = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const createPermission = async () => {
    // check if already formData contains some data then initialize it with empty
    setRoleModal(false);
    try {
      setLoading(true);
      let api_res = await DEATH_API.addPermission({
        name: formData.name,
        api: formData.api,
      });
      setLoading(false);
      if (api_res && api_res.status === 400) {
        swal("Error", api_res.message, "error");
      }
      getPermissionList();
      // return api_res;
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
    setFormData(null);
    setUpdateObject(null);
  };

  const updatePermission = async () => {
    // check if already formData contains some data then initialize it with empty
    setRoleModal(false);
    try {
      setLoading(true);
      let api_res = await DEATH_API.updatePermission(selectedIndex, formData);
      setLoading(false);
      if (api_res && api_res.status === 400) {
        swal("Error", api_res.message, "error");
      }
      getPermissionList();
    } catch (error) {
      console.log(error);
      setLoading(false);
      throw new Error(error);
    }
    setFormData(null);
    setUpdateObject(null);
  };

  const deleteSelectedRow = async (idx) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.deletePermission(idx);
          setLoading(false);
          getPermissionList();
        } catch (error) {
          console.log("error deleting Role");
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          setLoading(true);
          swal("Deleted!", "Permission has been deleted.", "success");
          setLoading(false);
        }, 0);
      } else {
        swal("Cancelled", "Your Permission is safe :)", "error");
      }
    });
  };

  const handleChange = (value) => {
    setFormData({
      ...formData,
      ["api"]: value,
    });
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const handleSearch = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setSearchTerm(searchTerm);
    const filteredResults =
      permissionList &&
      permissionList.filter((item) =>
        item.name.toLowerCase().includes(searchTerm)
      );
    setFilteredData(filteredResults);
  };

  return (
    <div className="mainRole">
      <div className="rolesTable">
        <div className="RolesHeader">
          <div className="RoleTitle">Permission List</div>

          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                border: "1px solid #2a3da3",
                borderRadius: "5px",
                marginRight: "1rem",
                height: "2rem",
              }}>
              <img
                style={{ marginTop: "6px", marginLeft: "6px" }}
                width={"20px"}
                height={"20px"}
                src={SearchIcon}
                alt="search"></img>
              <input
                className="searchInput"
                type="text"
                name="search"
                placeholder="Search"
                onChange={handleSearch}></input>
            </div>
            <label
              className="labelStyle"
              onClick={() => {
                setRoleModal(true);
              }}>
              +
            </label>
          </div>
        </div>
        <List
          cols={cols}
          rows={
            filteredData && filteredData.length > 0
              ? filteredData
              : permissionList
          }
        />
      </div>
      {roleModal && (
        <Modal
          visible={roleModal}
          centered
          footer={null}
          // onOk={handleOk}
          // onCancel={handleCancel}
          closable={false}>
          <h3 className="modaltitle">
            {" "}
            {updatedObject && updatedObject
              ? "Update Permission"
              : "Add New Permission"}
          </h3>

          <h3 className="inputTitle">Permission Name</h3>
          <input
            className="roleInput"
            placeholder="Permission Name"
            name="name"
            id="Permission"
            value={formData && formData.name}
            onChange={(e) => {
              e.preventDefault();
              handleInputChnage(e.target.name, e.target.value);
            }}
          />
          <h3 className="inputTitle">Permissions End Points</h3>
          <Select
            showSearch
            placeholder="Select Permissions"
            listHeight="120"
            value={formData && formData.api}
            onChange={handleChange}>
            {permissionList &&
              permissionList.map((item, index) => (
                <Option key={index} value={item.api}>
                  {item.api}
                </Option>
              ))}
          </Select>
          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancel();
              }}>
              Cancel
            </button>
            <button
              className="savebutton"
              onClick={() => {
                if (updatedObject) {
                  updatePermission();
                } else {
                  createPermission();
                }
              }}>
              Save
            </button>
          </div>
        </Modal>
      )}
      <NewLoader isLoading={loading} />
    </div>
  );
};
